import { IMachine } from '../machines/machines'
import { machines } from '../machines/machines-sidecar'
import { monsters } from '../monsters/monsters-sidecar'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, ITask } from './jobs'
import { jobs } from './jobs-sidecar'
import { createTask_goToMachine } from './taskGoToMachine'
import { createTask_takeOffSuit } from './taskTakeOffSuit'

export function createTask_enterShip(i: number, j: number): ITask {
  return jobs._createTask(i, j, 'enter-ship', {})
}

export function runTask_enterShip(job: IJob, task: ITask) {
  jobLogger.assertTaskType(task, 'enter-ship')
  let m = jobLogger.assertReserved(job)

  if (jobLogger.runSubtasks(job, task)) {
    return
  }

  if (jobLogger.isWaitingForPathOrMovement(job)) {
    return
  }

  if (m.isInsideShip) {
    // We are already inside!
    if (m.data.needsSuit && m.isInSuit) {
      // Take off suit!
      task.subtasks.push(createTask_takeOffSuit(m.i, m.j))
      return
    }
    return jobLogger.succeedTask(job, task)
  }

  let f = (c: IMachine) => c.data.type === 'airlock2'

  if (machines.findAtSpot(m.i, m.j, f)) {
    // Here!
    monsters.setInsideOutside(m, true)
    return // jobLogger.succeedTask(job, task)
  }

  // Add move to machine task
  task.subtasks.push(createTask_goToMachine(m.i, m.j, f))
}
